import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DataRest, PaginatedTasks, StatusData, TaskStatesData, TaskTypesData } from '../model/api/data-rest';
import { environment } from 'src/environments/environment';
import { resources } from './api';
import { PaginationParams, toHttpParams } from '../model/api/pagination-params';


@Injectable({
    providedIn: 'root'
})
export class TasksService {

    constructor(
        private http: HttpClient
    ) {
    }

    getTasks(deviceId: number, running?: boolean, finished?: boolean, userId?: number, paging?: PaginationParams): Observable<PaginatedTasks> {
        let params = new HttpParams();
        if (paging) {
            params = toHttpParams(paging);
        }
        if (deviceId !== undefined) {
            params = params.set('deviceid', deviceId.toString());
        }
        if (running !== undefined) {
            params = params.set('running', running.toString());
        }
        if (finished !== undefined) {
            params = params.set('finished', finished.toString());
        }
        if (userId) {
            params = params.set('userid', userId.toString());
        }
        return this.http.get<PaginatedTasks>(`${environment.apiUrl}${resources.get('tasks')}`, { params });
    }

    abortTask(taskId: number): Observable<DataRest> {
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('tasks')}${resources.get('abort')}`, { Tasks: [taskId] });
    }

    getTaskStates(language: string): Observable<TaskStatesData> {
        const params = new HttpParams().set('language', language);
        return this.http.get<TaskStatesData>(`${environment.apiUrl}${resources.get('tasks')}${resources.get('states')}`, { params });
    }

    getTaskTypes(language: string): Observable<TaskTypesData> {
        const params = new HttpParams().set('language', language);
        return this.http.get<TaskTypesData>(`${environment.apiUrl}${resources.get('tasks')}${resources.get('types')}`, { params });
    }


    getServiceStatus(): Observable<StatusData> {
        const headers = new HttpHeaders({
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0' // Un valore passato fa sì che la risorsa sia considerata scaduta immediatamente
        });

        return this.http.get<StatusData>(`${environment.apiStatus}`, { headers: headers });
    }
}
